<div class="graph-wrapper">
  <canvas id="myRadarChart" style="width: 276px; height: 258px"></canvas>
</div>
